<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Cancelación de Seguro
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-window v-model="step" show-arrows show-arrows-on-hover>   
                            <v-window-item :value="1">
                                <StepperSegurosClienteComponent :listSeguros="_.get(listGeneral,'listSeguros',[])"
                                                                :idSeguro="_.toNumber(obSearch.idSeguro)"
                                />
                            </v-window-item>

                            <div v-if="_.toNumber(obSearch.idSeguro) == _.toNumber(parametros.idSeguro)">
                                <v-window-item :value="2" >
                                    <StepperInformacionSeguroVehiculoComponent  :listCertificados="_.get(listGeneral,'listCertificados',[])"
                                                                                :parametros="parametros"
                                                                                :load="step == 2 ? true : false"
                                    />
                                </v-window-item>

                                <v-window-item :value="3">
                                    <StepperFormaDevolucionComponent  :listCertificados="_.get(listGeneral,'listCertificados',[])"
                                                                    :parametros="parametros"
                                                                    :nombreCliente="_.get(obSearch,'nombreCliente','')"
                                                                    :listTipoDevolucion="_.get(listGeneral,'listFormaDevolucion',[])"
                                                                    :listInstitucionFinanciera="_.get(listGeneral,'listIntitucionFinanciera',[])"
                                                                    :listTipoCuenta="_.get(listGeneral,'listTipoCuenta',[])"  
                                                                    :textoTerminoCondicionCancelacion="_.get(listGeneral,['listProductoParametros','0','textoTerminoCondicionCancelacion'],'')"                                                                
                                                                    :load="step == 3 ? true : false"
                                    />
                                </v-window-item>
                            </div>
                        </v-window>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'CancelacionView',
        components:{
            StepperSegurosClienteComponent: () => import('@/components/ajustePoliza/cancelacion/StepperSegurosClienteComponent.vue'),
            StepperInformacionSeguroVehiculoComponent: () => import('@/components/ajustePoliza/cancelacion/StepperInformacionSeguroVehiculoComponent.vue'),
            StepperFormaDevolucionComponent: () => import('@/components/ajustePoliza/cancelacion/StepperFormaDevolucionComponent.vue')
        },
        data: () => ({
            step:1,
            idCliente: null,
            idSeguro:null,
            listGeneral: {
                listCertificados: [],
                listSeguros: [],
            },
            parametros: {},
            obSearch: {
                idSeguro:null
            }
        }),
        created(){
            var error = 'E';

            axios.post(`${BASE_URI}administrador/cancelacion/cargaGeneral`,{}) 
                 .then((r) =>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) {error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                        this.listGeneral = r.data.data.listas;
                        this.parametros = r.data.data.parametros;
                        this.idCliente =  _.get(this.$root.obUsuario,'idCliente',null);

                        var o = {
                            opcion: 'LISTAR_CERTIFICADO_CANCELACION_VEHICULO',
                            idCliente: this.idCliente
                        };

                        return axios.post(`${BASE_URI}administrador/cancelacion/vehiculo/listarVehiculo`,o);
                 })
                 .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) {error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                        var l = _.map((_.chain(r.data.data).uniqBy('idSeguro').value()), _.partialRight(_.pick, ['idSeguro','seguro']));
                        this.listGeneral.listSeguros = _.map(l,(v)=>{
                                                            v.foto = v.foto = require(`@/assets/img/seguro/${v.idSeguro}.png`);
                                                            return v;
                                                        });
                 })
                 .catch((e) =>{
                     mensajesAlerta(e,'E');
                 })
        },
        watch:{
            step(val){
                switch (val) {
                    case 2:
                        if(_.toNumber(this.idSeguro) != _.toNumber(this.obSearch.idSeguro)){
                            this.onListarCertificados('L');
                            this.idSeguro = this.obSearch.idSeguro;
                        }
                        break;
                }
            }
        },
        methods: {
            onListarCertificados(event) {
                if (!_.isUndefined(event)) {
                    this.listGeneral.listCertificados = [];

                    switch (_.toNumber(this.obSearch.idSeguro)) {
                        case this.parametros.idSeguro:
                            this.onListarCertificadosSeguroVehiculo('L');
                            break;
                    }
                }
            },
            onListarCertificadosSeguroVehiculo(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var o = {
                        opcion: 'LISTAR_CERTIFICADO_CANCELACION_VEHICULO',
                        idSeguro: _.get(this.obSearch,'idSeguro',null),
                        idCliente: _.get(this, 'idCliente', null)
                    };

                    axios.post(`${BASE_URI}administrador/cancelacion/vehiculo/listarVehiculo`,o)
                         .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw r.data.mensaje; } 
                                this.listGeneral.listCertificados = _.map(r.data.data,(v) => { v.index = _.uniqueId();  return v; });
                         })
                         .catch((e) => {
                            mensajesAlerta(e, error);
                         });
                }
            },
            setData(keyNameObject,data)  {
                var z = _.get(this,keyNameObject,{});
                if(_.isArray(z))
                    _.set(this,keyNameObject,data);
                else
                    _.set(this,keyNameObject,_.merge({},z,data));
            },
            setStep(n){
                this.step = n;
            },
            preparateData() {
                try {
                    var objet = {error:true};
                    var keys = ['idCertificado','idPoliza','motivoCancelacion','idTipoDevolucion'];
                    var cer = _.get(this.obSearch, 'idCertificado', undefined);
                    var dia = _.get(this.listGeneral, ['listProductoParametros','0','cancelacionDiasCheque'],'');
                    
                    if (_.isUndefined(cer) || _.isNull(cer)) throw 'Debe seleccionar un certificado.';

                        var o = _.pick(this.obSearch, keys);

                        if (_.toNumber(this.obSearch.idTipoDevolucion) != this.parametros.id_tipo_devolucion_cheque) {

                            dia = _.get(this.listGeneral, ['listProductoParametros','0','cancelacionDiasTransferencia'],'');
                            var objeto = {
                                'opcion': 'I',
                                'numeroCta': this.obSearch.nroCuenta,
                                'idTipoCta': this.obSearch.idTipoCuenta,
                                'idTipoInstitucion': this.obSearch.idInstitucionFinaciera
                            };

                            o = _.merge({}, o, objeto);
                        }

                        var mensaje = `Tu reembolso se hará efectivo en ${dia} día(s) laborables. Te deseamos lo mejor y no dudes en renovar cuando quieras.`;

                        objet = {'objeto':o,'mensaje':mensaje,error:false};                            

                        return objet;
                } catch (e) {
                    mensajesAlerta(e, 'E');
                    return objet;
                }
            },
            insertarCancelacion() {  
                    var error = 'E';            
                    var o = this.preparateData();

                    if(!_.get(o,'error',true)) {
                        return axios.post(`${BASE_URI}administrador/cancelacion/vehiculo/insertOrUpdate`, o.objeto)
                                    .then((r) => {
                                        if(_.get(r,['data','existeError'],true)){ error="I"; throw _.get(r,['data','mensaje'], 'Ocurrio un error al realizar la petición.');}
                                            mensajeAlertaTiempo(o.mensaje,'S');
                                            setTimeout(() => {
                                                window.location.reload();
                                            }, 5000);
                                            return true;
                                    })
                                    .catch((e) => {
                                        mensajesAlerta(e, 'E');
                                    });
                    }else{
                        return new Promise((resolve,reject)=>{
                                    resolve(false);
                                });
                    }
            },
        },
        provide(){
            return{
                setData:this.setData,
                setStep:this.setStep,
                insertarCancelacion: this.insertarCancelacion
            }
        }
    }
</script>
<style>
    .v-window__next{
        display: none;
    }
</style>